import React from 'react'
import { useSelector } from 'react-redux'
import { List } from 'immutable'
import _get from 'lodash/get'
import { H2 } from '../../Heading/index'
import { selectStaticTextByKey } from '../../../services/static-text/selectors'
import { PlanGridCurrency } from '../../PlanGridCurrency/index'
import SherpaMessage from '../../SherpaMessage/index'
import { selectUserLanguagePrimary } from '../../../services/user/index'
import { EN } from '../../../services/languages/constants'
import { selectCurrencyIso, selectPlansLoaded } from '../../../services/plans/selectors'
import { get as getConfig } from '../../../config/index'
import { GIFT_PLAN_SELECT_KEY } from './gift-plan-select-key'
import { GiftPlanGrid } from './GiftPlanGrid'

const config = getConfig()
const planGraphQLActive = !!_get(config, ['features', 'checkout', 'planGraphQL'])

/**
 * @param {String} language
 * @returns {String} BEM language modificator
 */
function getLanguageSpecificClassName (language) {
  if (EN) {
    return ''
  }
  if (typeof language === 'string') {
    return `gift-plan-select__header-title--${language}`
  }
  return ''
}

/**
 * @type {import('react').FC}
 * */
export const GiftPlanSelect = (props) => {
  const { planData } = props
  const staticText = useSelector(selectStaticTextByKey(GIFT_PLAN_SELECT_KEY))
  let currencyIso = useSelector(selectCurrencyIso)
  let isPlansLoaded = useSelector(selectPlansLoaded)
  const userLanguage = useSelector(selectUserLanguagePrimary)

  if (planGraphQLActive && List.isList(planData) && planData.size) {
    isPlansLoaded = true
    currencyIso = planData.getIn([0, 'currencyIso'])
  }

  return (
    <div className="gift-plan-select">
      {isPlansLoaded ? (
        <>
          <div className="gift-plan-select__header">
            <H2
              className={`gift-plan-select__header-title ${getLanguageSpecificClassName(
                userLanguage,
              )}`}
            >
              {staticText.get('title')}
            </H2>
            {currencyIso && (
              <PlanGridCurrency
                currencyIso={currencyIso}
                className="gift-plan-select__currency-taxes"
              />
            )}
          </div>
          <GiftPlanGrid planData={planData} />
        </>
      ) : (
        <SherpaMessage
          message={staticText.get('loadingPlans')}
          arrow={false}
          center
        />
      )}
    </div>
  )
}

export default GiftPlanSelect
